export default __webpack_public_path__ + "static/media/ic-streaming-mic-off-dark.4e9f9fce.svg";